import { render, staticRenderFns } from "./roleauth.vue?vue&type=template&id=3c0255ae&scoped=true&"
import script from "./roleauth.vue?vue&type=script&lang=js&"
export * from "./roleauth.vue?vue&type=script&lang=js&"
import style0 from "./roleauth.vue?vue&type=style&index=0&id=3c0255ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0255ae",
  null
  
)

export default component.exports